var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5308",
    "data-name": "Group 5308",
    transform: "translate(-1482 -352)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1942",
    "data-name": "Rectangle 1942",
    width: 45,
    height: 45,
    rx: 22.5,
    transform: "translate(1482 352)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5304",
    "data-name": "Group 5304",
    transform: "translate(1497 367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bars-staggered",
    d: "M0,1.446A1.444,1.444,0,0,0,1.446,2.892H16.873a1.446,1.446,0,1,0,0-2.892H1.446A1.444,1.444,0,0,0,0,1.446Z",
    transform: "translate(14.999 2.045) rotate(135)",
    fill: "#3160d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bars-staggered-2",
    "data-name": "bars-staggered",
    d: "M0,1.446A1.444,1.444,0,0,1,1.446,0H16.874a1.446,1.446,0,0,1,0,2.893H1.446A1.444,1.444,0,0,1,0,1.446Z",
    transform: "translate(2.046 0) rotate(45)",
    fill: "#3160d4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/closeButton.da2777ede48c671f068be96299bcb382.svg";
export { ForwardRef as ReactComponent };